export default "__VITE_ASSET__a2e534e4__"